export { default } from './EquipmentMenuFilter';
